import { CategoriesIcon } from "@/theme/assets/icons";
import { CategorySelect } from "@/components";
import { Form } from "antd";

export const CategoryFilter = ({name = 'category', ...rest}) => {
    const form = Form.useFormInstance();

    const onChangeHandler = (value) =>{
        form.setFieldValue(name, value)
        form.submit()
    }

    return (
        <>
            <Form.Item
                noStyle
                name={name}
            >
                <div className={'prefix_icon_select_wrapper'}>
                    <div className={'prefix_icon'}>
                        <CategoriesIcon />
                    </div>
                    <CategorySelect
                        value={form.getFieldValue(name)}
                        placeholder={'Select category'}
                        onChange={onChangeHandler}
                        allowClear
                        style={{
                            width: 208,
                        }}
                        {...rest}
                    />
                </div>
            </Form.Item>
        </>
    );
}